<ng-container *ngIf="visaStandardRapport$ | async; else komborapport">
    <app-rapport-main />
</ng-container>

<ng-template #komborapport>
    <app-rapport-kombo-main />
</ng-template>
